import { render } from "./TableNews.vue?vue&type=template&id=4c33026b"
import script from "./TableNews.vue?vue&type=script&lang=js"
export * from "./TableNews.vue?vue&type=script&lang=js"

import "./TableNews.vue?vue&type=style&index=0&id=4c33026b&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__